import { styled } from "style";

const Text = styled("div")({});

export default Text;
